import type { CrossReferenceOccurrence } from 'features/knowledgeDocumentViewer/utils/crossReference'
import type { MouseEvent } from 'react'
import { createContext, useContext } from 'react'

export const CrossReferenceContext = createContext<
  | {
      marker?: { page: number; point: [number, number]; loading: boolean }
      onContextMenu: (
        occurrence: CrossReferenceOccurrence,
        event: MouseEvent
      ) => void
    }
  | undefined
>(undefined)
export const useCrossReferenceContext = () => useContext(CrossReferenceContext)
